<template>
  <div>
    <div class="phone-audio-content">
      <audio
        ref="audio"
        @pause="onPause"
        @play="onPlay"
        @timeupdate="onTimeupdate"
        @loadedmetadata="onLoadedmetadata"
        :src="audioFile"
        controls="controls"
        style="display: none;"
      ></audio>
      <div class="show-audio">
        <!-- <img v-if="cont.coverimgPathList.length > 0" :src="cont.coverimgPathList[0]" alt="" /> -->
        <div v-if="cont.lowPath" class="have-cover">
          <el-image :src="cont.lowPath" fit="cover" :class="this.audio.playing?'adimat-box':''">
            <div slot="error" class="image-slot">
              <img :src="require('@/assets/img/default.png')">
            </div>
          </el-image>
        </div>
        <div v-else class="have-cover">
          <img :src="require('@/assets/img/preview/defult.png')" alt="" :class="this.audio.playing?'adimat-box':''">
        </div>
        <!-- <img v-else :class="this.audio.playing?'adimat-box':''" :src="require('@/assets/img/preview/audiobg.png')" alt=""> -->
      </div>
      <div class="audio-phone-control">
        <div class="audio-control-display">
          <span class="audio-phone-time">{{realFormatSecond(this.audio.currentTime)}}</span>
          <div class="audio-phone-progress">
            <el-slider
              v-model="sliderTime"
              :format-tooltip="formatProcessToolTip"
              @change="changeCurrentTime"
              class="slider"
            ></el-slider>
          </div>
          <span class="audio-phone-time">{{audioInfo.time}}</span>
        </div>
      </div>
      <div class="audio-phone-button">
        <img @click="changeTime(-1)" style="width:20px;height:18px" :src="require('@/assets/img/preview/快退.png')" alt=""/>
        <img v-if="!this.audio.playing" style="width:56px;height:56px" @click="play" :src="require('@/assets/img/palying.png')" alt=""/>
        <img v-else @click="pause" style="width:56px;height:56px" :src="require('@/assets/img/puseing.png')" alt="" />
        <img @click="changeTime(1)" style="width:20px;height:18px" :src="require('@/assets/img/preview/快进.png')" alt=""/>
      </div>
    </div>
    <div class="news-cont-box">
      <p class="title">{{ title }}</p>
      <ul class="time">
        <li v-if="source">{{ source }}</li>
        <li>{{ createTime }}</li>
      </ul>
      <p class="news-box" v-if="cont.news">{{cont.news}}</p>
      <ul style="color:#666;line-height:28px;font-size: 14px;margin:6px 0;">
        <li v-if="cont.editor"><i style="margin-right:5px">|</i>编辑: {{cont.editor}}</li>
        <li v-if="cont.author"><i style="margin-right:5px">|</i>责任编辑: {{cont.author}}</li>
      </ul>
      <div
        v-if="wmkUse!=='0'"
        style="text-align:left;margin-bottom:16px;color: #999;font-size: 12px;"
        :style="{fontSize:waterMark.wmkWordSize+'px',opacity:(waterMark.wmkWordTrans/100)}">
        {{waterMark.wmkWordContent}}
      </div>
    </div>
  </div>
</template>

<script>
import * as sctipts from "../service/share";
import share from "../utils/share";
export default {
  data () {
    return {
      cont:'',
      pageType:1,
      audioFile: '',
      title: "",
      author: "",
      createUser:"",
      source: "",
      createTime: "",
      fullWord: "",
      webcommentList: [],
      type: "0",
      versionUrl: "",
      appName: "",
      appIcon: '',
      anyangIcon: require('../assets/img/logo.png'),
      shareIcon: require('../assets/img/shareLogo.png'),
      editor: "",
      linkList: [],
      newList: [],
      showFullContent: false,
      appScheme: "",
      viewTotal: "",
      timer: null,
      // 水印
      waterMark: {},
      // 是否开启水印 wmkUse 0 否 1 是
      wmkUse: 0,


      showMouse:false,
      followBtn:false,
      newSoundValue: 75,
      soundValue:75,
      sound:false,
      sliderTime: 0,
      audioDetail: {},
      audioInfo: {
        time: 0,
      },
      progressing_audio: 0,
      audio: {
        // 该字段是音频是否处于播放状态的属性
        playing: false,
        // 音频当前播放时长
        currentTime: 0,
        // 音频最大播放时长
        maxTime: 0,
      },
    };
  },
  created () {
    window.audioPause = this.audioPause;
  },
  computed: {
    shareId () {
      return this.$route.query.id
    },
  },
  mounted () {
    if (this.equipmentType() == "iOS") {
      this.type = 0;
    } else if (this.equipmentType() == "Android") {
      this.type = 1;
    } else {
      this.type = 3;
    }
    if (this.$route.query.id) {
      sctipts
        .getCont({
            id:this.$route.query.id,
            type:this.$route.query.type
    })
        .then(({
          data
        }) => {
          if (data.status == 0) {
            if (data.data) {
              this.cont = data.data
              this.audioFile = data.data.path
              this.title = data.data.title || "";
              this.source = data.data.source || "";
              this.author = data.data.author || "";
              this.editor = data.data.editor || "";
              this.createUser = data.data.createUser || "";
              this.createTime = sctipts.initTime(data.data.createTime, 2);
              this.fullWord = data.data.fullWord || "";
              this.viewTotal = data.data.viewTotal || '0';
              document.title = this.title;
              this.linkList = data.data.linkList?data.data.linkList.slice(0,3):[];
              this.newList = data.data.newList;
              this.wmkUse = data.data.wmsUse;
              let obj={
                title: data.data.title,
                desc: data.data.news,
                link: location.href,
                img: this.appIcon,
              }
              let url = process.env.NODE_ENV === 'production' ? window.location.href : process.env.VUE_APP_URL+this.$route.fullPath;
              share.getJSSDK(url.split('#')[0],obj)
              if (this.wmkUse == 1) {
                // 获取文章水印列表
                  let obj = {
                    pageIndex: 1,
                    pageSize: 99999,
                    wmkRange: 1,
                  };
                  sctipts.getWater(obj).then((res) => {
                    if (res.data.status === 0 && res.data.data.list) {
                      var waterData = res.data.data.list.filter((val) => {
                        return val.wmkId == data.data.wmkId
                      })
                      this.waterMark = waterData[0]
                    };
                  })
              }
            }
          } else {
            console.log(data.desc);
          }
        })
        .catch((res) => {
          console.log("连接服务器错误");
        });
    } else {
      console.log("未获取id");
    }
  },
  methods: {
    equipmentType () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    initTime (time, type) {
      return sctipts.initTime(time, type);
    },
    getDateDiff (time) {
      return sctipts.getDateDiff(time);
    },
    imgPath (event) {
      if (event.target.nodeName == "IMG") {
        // 获取触发事件对象的属性
        let allPathArr = [];
        let index = "";
        for (
          let i = 0; i < this.$refs.Introduction.querySelectorAll("img").length; i++
        ) {
          allPathArr.push(
            this.$refs.Introduction.querySelectorAll("img")[i].src
          );
        }
        allPathArr.forEach((val, ind) => {
          if (val == event.target.src) {
            index = ind;
          }
        });

        let objData = {
          thisPath: event.target.src,
          allPath: allPathArr,
          indexOf: index,
        };
        if (this.equipmentType() == "iOS") {
          window.webkit.messageHandlers.showImage.postMessage(objData);
        } else if (this.equipmentType() == "Android") {
          Android.openImage(event.target.src, allPathArr, index);
        }
      }
    },
    openApp (item) {
      let path = this.$route.push
      this.$router.push({path,query:{id:item.releaseSourceId,bundleID:this.$route.query.bundleID}})
    },
    downApp (item) {
      // 1文章,2 视频, 3  电视直播, 4 活动直播, 5 栏目详情, 6 图片详情, 7 爆料详情
      var link=''
        if (item.releaseSourceId) {
          link = `${this.appScheme}://${this.$getModules(8)}?sourceId=${item.releaseSourceId}`;
        }else{
          link = `${this.appScheme}://${this.$getModules(8)}?sourceId=${this.$route.query.id}`;
        }
      var downUrl = location.origin+'/invitation?type='+this.$route.query.type+'&bundleID='+this.$route.query.bundleID;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          var loadDateTime = new Date();
          window.setTimeout(function() {
              var timeOutDateTime = new Date();
              if (timeOutDateTime - loadDateTime < 5000) {
                //下载分享页
                window.location = downUrl;
              } else {
                window.close();
              }
          },500);
          window.location = link;
        }
      } else if (navigator.userAgent.match(/android/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          window.location.href = link;
          window.setTimeout(() => {
            //下载分享页
            window.location = downUrl
          }, 2500);
        }
      }
    },
    returnImgPath (row) {
      if (row.coverimgStyleId == 0) {
        return require("@/assets/img/default.png");
      } else {
        if (row.coverimgLowPathList) {
          if (row.coverimgLowPathList[0]) {
            return row.coverimgLowPathList[0];
          } else if (row.coverimgPathList) {
            if (row.coverimgPathList[0]) {
              return row.coverimgPathList[0];
            }
          }
        } else if (row.coverimgPathList) {
          if (row.coverimgPathList[0]) {
            return row.coverimgPathList[0];
          }
        } else {
          return "";
        }
      }
    },
    audioPause () {
      this.$refs.Introduction.querySelectorAll("audio").forEach((element) => {
        element.pause();
      });
    },
    getDate(time){
      let Time
      if (time) {
        Time = new Date(time);
      } else {
        Time = new Date();
      }
      let m = Time.getMonth() + 1;
      let d = Time.getDate();
      m = m>9?m:'0'+m
      d = d>9?d:'0'+d
      return `${m}-${d}`;
    },
    // initTime (time) {
    //   let Time
    //   if (time) {
    //     Time = new Date(time);
    //   } else {
    //     Time = new Date();
    //   }
    //   let y = Time.getFullYear();
    //   let m = Time.getMonth() + 1;
    //   let d = Time.getDate();
    //   let h = Time.getHours();
    //   let mm = Time.getMinutes();
    //   let s = Time.getSeconds();
    //   // ${y}-${m}-${d} ${h}:${mm}:${s}
    //   return `${y}-${m}-${d} ${h}:${mm}`;
    // },
    // 音频时间
    realFormatSecond(second) {
      var secondType = typeof second
      if (secondType === 'number' || secondType === 'string') {
        second = parseInt(second)
        var hours = Math.floor(second / 3600)
        second = second - hours * 3600
        var mimute = Math.floor(second / 60)
        second = second - mimute * 60
        //   return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
        return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
      } else {
        return '00:00'
      }
    },
    // 控制音频的播放与暂停
    startPlayOrPause() {
      return this.audio.playing ? this.pause() : this.play();
    },

    // 播放音频
    play() {
      this.$refs.audio.play();
      this.timer = setInterval(() => {
        this.progressing_audio =
          (this.progressing_audio / 100 + 0.1 / this.audio.maxTime) * 100;
        this.second = this.second + 0.1;
        if (this.progressing_audio >= 100) {
          clearInterval(this.timer);
          this.progressing_audio = 0;
          this.second = 0;
        }
      }, 100);
    },
    // 暂停音频
    pause() {
      this.$refs.audio.pause();
      clearInterval(this.timer)
    },
    // 当音频播放
    onPlay() {
      this.audio.playing = true;
    },
    // 当音频暂停
    onPause() {
      this.audio.playing = false;
    },
    // 进度条toolTip
    formatProcessToolTip(index) {
      index = parseInt(this.audio.maxTime / 100 * index)
      return '进度条: ' + this.realFormatSecond(index)
    },
    // 播放跳转
    changeCurrentTime(index) {
      this.$refs.audio.currentTime = parseInt(index / 100 * this.audio.maxTime)
    },
    changeTime (type) {
      if (this.audio.currentTime + (15*type)<=0) {
        this.$refs.audio.currentTime = 0
      }else if (this.audio.currentTime + (15*type)>this.audio.maxTime) {
        this.$refs.audio.currentTime = this.audio.maxTime
      }else{
        this.$refs.audio.currentTime = this.audio.currentTime + (15*type)
      }
    },
    // 当timeupdate事件大概每秒一次，用来更新音频流的当前播放时间
    onTimeupdate(res) {
      this.audio.currentTime = res.target.currentTime;
      this.sliderTime = this.audio.currentTime / this.audio.maxTime * 100
    },
    // 当加载语音流元数据完成后，会触发该事件的回调函数
    // 语音元数据主要是语音的长度之类的数据
    onLoadedmetadata(res) {
      this.audioInfo.time = this.realFormatSecond(parseInt(res.target.duration));
      this.audio.maxTime = parseInt(res.target.duration);
    },
    showSound () { //声音
      this.sound = !this.sound
      if (this.sound) {
        this.soundValue = 0
        this.$refs.audio.volume = this.soundValue / 100
      } else {
        this.soundValue = this.newSoundValue
        this.$refs.audio.volume = this.soundValue / 100
      }
    },
    getChange () {
      this.sound = false
      this.newSoundValue = this.soundValue
      this.$refs.audio.volume = this.newSoundValue / 100
    },
  },
  filters: {
    // 使用组件过滤器来动态改变按钮的显示
    transPlayPause(value) {
      return value ? "el-icon-video-pause" : "el-icon-video-play";
    },
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.audio-control-display{
  display: flex;
  align-items: center;
  margin: auto;
}
.show-audio{
  margin: 0;
}
.phone-audio-content{
  padding-top: 12px;
}
.audio-phone-progress{
  width: 245px;
  margin: 0 12px;
}
.audioFile {
  display: block;
  width: 90%;
  margin: 20px auto;
}
.news-cont-box {
  padding: 0 16px;
  box-sizing: border-box;
  overflow: hidden;
}
.title {
  max-height: 50px;
  font-weight: bold;
  margin-top: 20px;
  color: #333;
  font-weight: 700;
  font-size: 18PX;
  font-family: SourceHan;
  line-height: 1.3;
  letter-spacing: 0;
  text-align: left;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.news-box{
  margin-bottom: 12px;
  font-size: 14px;
  font-family: SourceHan;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.time {
  display: flex;
  align-items: center;
  margin: 12px 0;
}

.time > li {
  margin-right: 10px;
  color: #999;
  font-size: 12PX;
  line-height: 1.5;
  font-family: SourceHan;
}

.Introduction-hidden {
  height: 300px;
  overflow: hidden;
  position: relative;
}

.Introduction-hidden-icon {
  content: "";
  width: 100%;
  height: 200px;
  background-image: linear-gradient(transparent, #fff);
  z-index: 9999;
  margin-top: -200px;
  position: relative;
}

.Introduction-hidden-icon img {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
}

.open-app {
  width: 100%;
  display: block;
  border: none;
  height: 44px;
  background-color: #be1928;
  color: #fff;
  font-size: 14px;
  border-radius: 30px;
  margin-bottom: 22px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
}

.open-app-border {
  width: 100%;
  display: block;
  border: none;
  height: 44px;
  border: 1px solid #be1928;
  color: #be1928;
  font-size: 14px;
  border-radius: 5px;
  margin-bottom: 22px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
}

.all-com-title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-bottom: 0px;
}
.video-links {
  overflow: hidden;
  margin-top: 17px;
  /* margin-bottom: 20px; */
}
.video-links-item {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.links-item-text{
  width: calc(100% - 145px);
}
.links-item-text p {
  font-size: 16px;
  color: #333333;
  margin-bottom: 5px;
  text-align: justify;
  height: 60px;
  line-height: 30px;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.links-item-text span {
  display: inline-block;
  font-size: 12px;
  color: #8a8a8a;
  display: block;
  line-height: 18px;
}
.video-links-item-img {
  height: 85px;
  width: 125px;
  border-radius: 5px;
  position: relative;
  border:none;
  margin-top: 10px;
  overflow: hidden;
  margin-right: 15px;
}
.video-links-item-img .back-img {
  object-fit: contain;
  height: 100%;
  width: 100%;
  display: block;
}
.item-img-icon-box{
  position: absolute;
  left: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
  font-size: 10px;
  font-family: SourceHan;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 12px;
}
.video-links-item-img-icon {
  width: 8px;
  height: 10px;
  margin-right: 5px;
}
</style>
<style>
.audio-phone-progress .el-slider__button-wrapper .el-slider__button{
  border: none;
  background-color: #be1928;
  width: 8px;
  height: 8px;
  display: block;
}
.audio-phone-progress .el-slider__button-wrapper{
  width: 8px;
  height: 8px;
  top: -2px;
}
.audio-phone-progress .el-slider__runway{
  height: 5px;
 }
.audio-phone-progress .el-slider__bar{
  background-color: #be1928;
  height: 5px;
}
.down-app-btn-bottom {
  width: 58px;
  height: 24px !important;
  border-radius: 5px !important;
}

.Introduction{
  margin-bottom: 16px;
  margin-top: 22px;
  overflow-y: auto;
}
.Introduction img {
  width: 100%;
  display: block;
  margin: 5px auto;
  max-width: 100%;
  object-fit: scale-down;
}

.Introduction video {
  width: 100%;
  height: 200px;
  display: block;
  margin: 0 auto;
  max-width: 100%;
  background-color: #000;
}

.news-newList-box {
  width: 100%;
  height: 56px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99999;
  border-top: 1px solid #eee;
  background-color: #fff;
}

.news-newList .van-swipe-item {
  width: 100%;
  height: 56px;
  line-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 13px;
  box-sizing: border-box;
}

.news-newList .van-swipe__indicators {
  bottom: 7px;
}
</style>
